// ✅ HeaderRunwayStyle.jsx (corrigé avec alignement + responsive)

import React, { useEffect, useState } from 'react';
import logo from './assets/logofinal.png';

const HeaderRunwayStyle = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const headerStyle = {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    backgroundColor: !scrolled ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.95)',
    backdropFilter: !scrolled ? 'blur(10px)' : 'none',
    boxShadow: !scrolled ? '0 1px 8px rgba(0,0,0,0.06)' : 'none'
  };

  return (
    <header className="py-2 px-3" style={headerStyle}>
      <div className="container d-flex justify-content-between align-items-center">
        {/* Logo + Découvrir */}
        <div className="d-flex align-items-center gap-3">
          <a href="/" className="d-flex align-items-center text-decoration-none">
            <img
              src={logo}
              alt="Logo"
              style={{ height: '48px', objectFit: 'contain' }}
            />
          </a>
          <a
            href="#trending-media"
            className="fw-semibold text-dark text-decoration-none"
            style={{ fontSize: '1rem' }}
          >
            ✨ Découvrir
          </a>
        </div>

        {/* Boutons droit */}
        <div className="d-flex align-items-center gap-2">
          <a
            href="/login"
            className="btn btn-danger rounded-pill px-3"
            style={{ fontWeight: 600 }}
          >
            Se connecter
          </a>
          <a
            href="/register"
            className="btn btn-outline-dark rounded-pill px-3"
            style={{ fontWeight: 600 }}
          >
            S’inscrire
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderRunwayStyle;
